import { useTranslation } from "react-i18next";
import { TruncatedTextTooltip } from "components/common/TruncatedTextTooltip";
import { formatQuantityValue } from "../../utils/formatQuantityValue";
import { QuantityDelta } from "../QuantityDelta";
import { QUANTITY_GRID_CLASS } from "../constants";
import type { QuantityDiffRowProps } from "./types";

export const QuantityDiffRow = ({ entry, kind }: QuantityDiffRowProps) => {
  const { i18n } = useTranslation();

  const formatValue = (value: number) =>
    formatQuantityValue({ value, language: i18n.language, kind });

  return (
    <div
      className={`${QUANTITY_GRID_CLASS} rounded-lg px-2 py-2 transition-colors hover:bg-gray-50 sm:px-3`}
    >
      <div className="min-w-0">
        <TruncatedTextTooltip
          text={entry.name}
          className="block text-sm text-gray-800"
        />
        {entry.lvPosition !== null && (
          <p className="truncate font-mono text-xs text-gray-500">
            {entry.lvPosition}
          </p>
        )}
      </div>
      <span className="whitespace-nowrap text-right text-xs tabular-nums text-gray-700 sm:text-sm">
        {entry.status === "added" ? "—" : formatValue(entry.beforeQuantity)}
      </span>
      <span className="whitespace-nowrap text-right text-xs tabular-nums text-gray-700 sm:text-sm">
        {entry.status === "removed" ? "—" : formatValue(entry.afterQuantity)}
      </span>
      <span className="text-right">
        <QuantityDelta delta={entry.delta} kind={kind} />
      </span>
    </div>
  );
};
